module.exports = __webpack_public_path__ + "static/media/result-2-zh-HK.565906c5.png";